export default __webpack_public_path__ + "static/media/Despairingly Stigmatize_ Searing Resolution.a5cb6fde.png";